import { listingStatuses } from "../constants/listingStatuses";

export const translatedStatusesOptions = {
    [listingStatuses.sold.id]: 'SoldListSide',
    [listingStatuses.forSale.id]: 'ForSale',
    [listingStatuses.newListings.id]: 'New',
    [listingStatuses.underContract.id]: 'UnderContract',
    [listingStatuses.expired.id]: 'Expired',
    [listingStatuses.forSaleLdm.id]: 'ForSaleLastDay',
};
